import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { HelmetProvider } from 'react-helmet-async';
import { PersistGate } from "redux-persist/integration/react";

import "antd/dist/reset.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

import App from "./App";
import store, { persistor } from "./store";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <HelmetProvider>
          <BrowserRouter 
          basename={process.env.PUBLIC_URL}
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
          >
            <App />
            <ToastContainer />
          </BrowserRouter>
        </HelmetProvider>
      </PersistGate>
    </Provider>
  </StrictMode>
);
